export const normalize = function(path: string, stripTrailing: boolean = false) {
	if (typeof path !== 'string') {
		throw new TypeError('expected path to be a string');
	}

	if (path === '\\' || path === '/') return '/';

	const len = path.length;
	if (len <= 1) return path;

	// ensure that win32 namespaces has two leading slashes, so that the path is
	// handled properly by the win32 version of path.parse() after being normalized
	// https://msdn.microsoft.com/library/windows/desktop/aa365247(v=vs.85).aspx#namespaces
	let prefix = '';
	if (len > 4 && path[3] === '\\') {
		const ch = path[2];
		if ((ch === '?' || ch === '.') && path.slice(0, 2) === '\\\\') {
			path = path.slice(2);
			prefix = '//';
		}
	}

	const segs = path.split(/[/\\]+/);
	if (stripTrailing !== false && segs[segs.length - 1] === '') {
		segs.pop();
	}
	return prefix + segs.join('/');
};

export const escapeRegExp = (value: string) => {
	return value.replace(/[-[\]{}()*+?.,\\/^$|#\s]/g, '\\$&');
};

/**
 * Trims extra spaces from multiline string
 * @param {string} value
 */
export const trimExtraIndentationMultiLineText = (value: string): string => {
	const regExp = /\s{1,}/;
	const splitted = value.split('\n');
	const formated: Array<string> = [];
	let minIndent: number;

	splitted.forEach((codeLine) => {
		const matchedIndentation = codeLine.match(regExp);

		if (matchedIndentation && matchedIndentation.index === 0) {
			const indentationCount = matchedIndentation[0].length;

			if (!minIndent || indentationCount < minIndent) {
				minIndent = indentationCount;
			}
		}
	});

	splitted.reduce((acc, codeLine) => {
		const matchedIndentation = codeLine.match(regExp);
		let formatedCode = codeLine;

		if (matchedIndentation && matchedIndentation.index === 0) {
			formatedCode = codeLine.slice(minIndent);
		}

		acc.push(formatedCode);

		return acc;
	}, formated);

	return formated.join('\n');
};

export const uuidv4 = () => {
	// return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
	// 	(c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
	// );
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		const r =
				(parseFloat(
					'0.' +
						Math.random()
							.toString()
							.replace('0.', '') +
						new Date().getTime()
				) *
					16) |
				0,
			v = c == 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
};
